import React, { useEffect, useState } from "react";
import { Heading } from "../../elements";
import "./style.scss";
const IconList = props => {
  const { fields } = props;
  const { titleType, title, items, pcBg, mobileBg } = fields;
  const _rootStyle = pcBg.value?.src && {
    backgroundImage: `linear-gradient(to top right, #000, rgba(0,0,0, 0.3) 50%,transparent), url(${pcBg.value?.src})`
  };
  const [rootStyle, setRootStyle] = useState(_rootStyle);
  useEffect(() => {
    const onResize = () => {
      let bg;
      if (window.innerWidth < 992) {
        bg = mobileBg.value?.src ?? pcBg.value?.src;
      } else {
        bg = pcBg.value?.src ?? mobileBg.value?.src;
      }

      let tempStyle = bg && {
        backgroundImage: `linear-gradient(to top right, #000, rgba(0,0,0, 0.3) 50%,transparent), url(${bg})`
      };
      setRootStyle(tempStyle);
    };
    window.addEventListener("resize", onResize);
    onResize();
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);
  return (
    <div className="c-icon-list grid" style={rootStyle}>
      <div className="c-icon-list__header">
        <Heading html={title} type={titleType} className="__f-h2" />
      </div>
      <div className="c-icon-list__main">
        {items.map(item => (
          <div className="c-icon-list__item show-on-scroll" key={item.id}>
            <div className="c-icon-list__item-image-box">
              <img className="c-icon-list__item-image" {...item.fields.icon.value} />
            </div>
            <div className="c-icon-list__item-title __f-h3">{item.fields.title.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default IconList;
